import React, {useState, useEffect} from 'react';
import {Modal, Button, Icon, Step} from 'semantic-ui-react';
import WtsAgendaViewOnly from './matriculaModal/WtsAgendaViewOnly';
import WtsCourseDocuments from './matriculaModal/WtsCourseDocuments';
import WtsMatriculaAbierta from './matriculaModal/WtsMatriculaAbierta';
import WtsVerCalificaciones from './matriculaModal/WtsVerCalificaciones';
import WtsDocumentacionFinal from './matriculaModal/WtsDocumentacionFinal';

const WtsMatriculaIndex = ({open, onClose, courseToEdit, reduxData}) => {
  const [activeStep, setActiveStep] = useState(1);

  useEffect(() => {
    if (open) {
      setActiveStep(1);
    }
  }, [open]);

  if (!open || !courseToEdit) {
    return null;
  }

  const courseStatus = courseToEdit?.status || courseToEdit?.estado;
  const isCourseActive = courseStatus === 'A';
  const isCourseFinished = ['E', 'C', 'X'].includes(courseStatus);
  const isCourseClosed = courseStatus === 'C';

  const stepsData = [
    {
      'id': 1,
      'icon': 'info circle',
      'title': 'Información',
      'desc': 'Detalles del curso',
      'content': <WtsAgendaViewOnly courseToEdit={courseToEdit} reduxData={reduxData} />,
    },
    {
      'id': 2,
      'icon': 'file pdf outline',
      'title': 'Documentos',
      'desc': 'Material de estudio',
      'content': <WtsCourseDocuments courseToEdit={courseToEdit} />,
    },
  ];

  if (isCourseActive) {
    stepsData.push({
      'id': stepsData.length + 1,
      'icon': 'calendar',
      'title': 'Inscripción',
      'desc': 'Listado de estudiantes',
      'content': <WtsMatriculaAbierta courseToEdit={courseToEdit} reduxData={reduxData} />,
    });
  }

  if (isCourseFinished) {
    stepsData.push({
      'id': stepsData.length + 1,
      'icon': 'star',
      'title': 'Calificaciones',
      'desc': 'Notas obtenidas',
      'content': <WtsVerCalificaciones courseToEdit={courseToEdit} reduxData={reduxData} />,
    });
  }

  if (isCourseClosed) {
    stepsData.push({
      'id': stepsData.length + 1,
      'icon': 'check circle',
      'title': 'Doc. Final',
      'desc': 'Actas y respaldos',
      'content': <WtsDocumentacionFinal courseToEdit={courseToEdit} reduxData={reduxData} />,
    });
  }

  const totalSteps = stepsData.length;

  const handleNext = () => {
    if (activeStep < totalSteps) {
      setActiveStep(activeStep + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 1) {
      setActiveStep(activeStep - 1);
    }
  };

  const currentStepData = stepsData.find((step) => step.id === activeStep);

  return (
    <Modal open={open} onClose={onClose} size="large" closeIcon>
      <Modal.Header>
        <Icon name="info circle" /> Detalle de Agenda de Curso
      </Modal.Header>

      <Modal.Content scrolling>
        <Step.Group widths={totalSteps} size="small" style={{'marginBottom': '2em'}}>
          {stepsData.map((step) => (
            <Step
              key={step.id}
              active={activeStep === step.id}
              onClick={() => setActiveStep(step.id)}
              style={{'cursor': 'pointer'}}
            >
              <Icon name={step.icon} />
              <Step.Content>
                <Step.Title>{step.title}</Step.Title>
                <Step.Description>{step.desc}</Step.Description>
              </Step.Content>
            </Step>
          ))}
        </Step.Group>

        {currentStepData && currentStepData.content}
      </Modal.Content>

      <Modal.Actions>
        {activeStep > 1 && (
          <Button basic color="blue" onClick={handleBack} style={{'float': 'left'}}>
            <Icon name="left chevron" /> Atrás
          </Button>
        )}
        {activeStep < totalSteps && (
          <Button color="blue" onClick={handleNext}>
            Siguiente <Icon name="angle right" />
          </Button>
        )}
        <Button color={activeStep === totalSteps ? 'green' : 'grey'} onClick={onClose}>
          {activeStep === totalSteps ? 'Finalizar' : 'Cerrar'}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default WtsMatriculaIndex;
